import type { AuthUser } from "@mind-sands/shared";

/** Shared admin check — do not compare `user.role` at call sites. */
export function isAdminUser(user: AuthUser | null | undefined): boolean {
  return user?.role === "admin";
}
